import { Tabs as TabsPrimitive } from '@base-ui/react/tabs';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const tabsListVariants = cva(
  [
    'group/tabs-list inline-flex w-fit items-center justify-center gap-0.5 rounded-md p-0.5',
    'text-gray-900',
    'group-data-horizontal/tabs:h-8',
    'group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col',
    'data-[variant=line]:rounded-none',
  ],
  {
    variants: {
      variant: {
        default: 'bg-white',
        line: 'gap-1 bg-transparent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type TabsListProps = TabsPrimitive.List.Props & VariantProps<typeof tabsListVariants>;

const TabsList = ({ className, variant = 'default', ...props }: TabsListProps) => {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      data-variant={variant}
      className={cn(tabsListVariants({ variant }), className)}
      {...props}
    />
  );
};

export default TabsList;
